<template>
<header>
  <div id="button" @click="isActive = !isActive" :class="{ active: isActive }">
    <div class="bar"></div>
    <div class="bar"></div>
    <div class="bar"></div>
  </div>
  <div id="menu" :class="{ active: isActive }">
    <ul class="content-container">
      <li class="extra-pad">
        <a href="/">de</a>/<a href="/en">en</a>
      </li>
      <li v-for="page in pages" :key="page.id">
        <p v-scroll-to="'#' + page.uid" @click="isActive = !isActive">{{ page.title }}</p>
      </li>
    </ul>
  </div>
</header>
</template>

<script>
export default {
  name: 'navigation',
  computed: {
    site() {
      return this.$store.state.site.site
    },
    pages() {
      const pages = this.$store.state.pages.pages
      const result = pages.filter(page => page.visible == true);
      return result
    }
  },
  data() {
    return {
      isActive: false
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

header {
    #button {
        position: fixed;
        top: $gap / 2;
        left: $gap / 2;
        width: $gap;
        z-index: 11;
        cursor: pointer;
        .bar {
            border-top: 2px solid $font-color;
            @media only screen and (max-width: $phone) {
                border-top: 1px solid $font-color;
            }
            padding-bottom: $gap / 4;
            &:last-of-type {
                padding-bottom: 0;
            }
        }
        &:hover {
            .bar {
                @media only screen and (max-width: $phone) {}
            }
        }
        &.active {
            .bar {
                &:nth-child(1) {
                    transform: rotate(-45deg) translate(-1.7rem, 1.7rem);
                }
                &:nth-child(2) {
                    opacity: 0;
                }
                &:nth-child(3) {
                    transform: rotate(45deg) translate(-23%, -350%);
                }
            }
        }
    }
    #menu {
        position: fixed;
        left: 0;
        top: 0;
        width: 50%;
        height: 100%;
        background: $bgcolor;
        z-index: 10;
        display: none;
        &.active {
            display: block;
        }
        ul {
            padding: $gap / 2;
            margin-top: $gap;
            display: flex;
            flex-direction: column;
            li {
                display: block;
                list-style: none;
                &.extra-pad {
                    padding-bottom: $gap;
                }
                a {
                    color: $font-color;
                }
                p {
                    cursor: pointer;
                }
            }
        }
    }

}
</style>
